module.exports = __webpack_public_path__ + "img/classiccar.7b42c7d1.jpg";